module.exports = __webpack_public_path__ + "img/barcelona.1c73e541.png";